import { TEDCustomNumberParser } from './TEDCustomNumberParser';
import { TEDParseNumberMode } from '../FormatterTypes';

export class TEDParseCurr extends TEDCustomNumberParser {
  public static getInstance(): TEDParseCurr {
    return this.instance ? this.instance : (this.instance = new this());
  }

  private static instance: TEDParseCurr;

  mode(): TEDParseNumberMode {
    return TEDParseNumberMode.pnmCurrency;
  }
}
